// src/clientesSwap/anexos/fileDropzone
import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Avatar,
  Tooltip,
  IconButton,
  alpha,
  useTheme,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import CloseIcon from "@mui/icons-material/Close";
import useStyles from "../styles";

const FileDropzone = ({
  // Dados
  files = [],
  dragActive = false,
  inputId = "input-upload",
  accept = "image/*,application/pdf,.doc,.docx,video/*",

  // Funções (Handlers)
  onDragOver = () => {},
  onDragLeave = () => {},
  onDrop = () => {},
  onFileChange = () => {},
  onRemoveFile = () => {},
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      sx={{
        ...styles.boxContainer,
        border: dragActive
          ? `2px dashed ${theme.palette.primary.main}`
          : `2px dashed ${alpha(theme.palette.text.primary, 0.3)}`,
        ...(files?.length === 0 && {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }),
      }}
    >
      <Typography color="text.secondary" sx={styles.textInfo} align="center">
        {dragActive
          ? "Solte os arquivos aqui"
          : "Arraste, cole (Ctrl+V) ou clique para selecionar"}
      </Typography>

      <input
        type="file"
        hidden
        multiple
        id={inputId}
        onChange={onFileChange}
        accept={accept}
      />

      <label htmlFor={inputId}>
        <Button
          variant="outlined"
          component="span"
          startIcon={<CloudUploadIcon />}
          sx={{ textTransform: "none", mb: 2, mt: 1 }}
        >
          Selecionar arquivos
        </Button>
      </label>

      {files.length > 0 ? (
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {files.map((file, index) => {
            const isImage = file.type?.startsWith("image/");
            // Como já geramos o preview no componente pai, apenas usamos ele aqui
            const preview = file.preview;
            const sizeBytes =
              typeof file.size === "number"
                ? file.size
                : typeof file.originalFile?.size === "number"
                  ? file.originalFile.size
                  : 0;
            const sizeLabel =
              sizeBytes > 0
                ? `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`
                : "";

            return (
              <Grid item xs={4} sm={3} key={index}>
                <Box sx={{ ...styles.boxImagePreview, position: "relative" }}>
                  {isImage ? (
                    <Avatar
                      src={preview}
                      alt={file.name}
                      variant="rounded"
                      sx={styles.avatar}
                    />
                  ) : (
                    <Tooltip title={file?.name || ""}>
                      <Box sx={styles.containerCard}>
                        <InsertDriveFileOutlined sx={{ fontSize: "60px" }} />
                        <Box sx={styles.boxTitleAnexo}>
                          <Typography sx={styles.boxTextAnexo} noWrap>
                            {file?.name}
                          </Typography>
                        </Box>
                      </Box>
                    </Tooltip>
                  )}
                  {sizeLabel && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "center",
                        mt: 0.5,
                        color: "text.secondary",
                      }}
                    >
                      {sizeLabel}
                    </Typography>
                  )}
                  <IconButton
                    size="small"
                    // Correção essencial: passar a referência do file ao invés do index numérico
                    onClick={() => onRemoveFile(file)}
                    sx={styles.iconButton}
                  >
                    <CloseIcon
                      fontSize="small"
                      sx={{ color: theme.palette.common.white }}
                    />
                  </IconButton>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Typography
          color="text.secondary"
          sx={{ ...styles.textInfo, fontSize: "0.8rem", mt: 1 }}
        >
          Nenhum arquivo selecionado
        </Typography>
      )}
    </Box>
  );
};

export default FileDropzone;
